import { render, staticRenderFns } from "./LaundryType.vue?vue&type=template&id=b41297b2&"
import script from "./LaundryType.vue?vue&type=script&lang=js&"
export * from "./LaundryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports